import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Hash,
  Clock,
  Package,
  Truck,
  CheckCircle
} from 'lucide-react';

const StatsCards = ({ stats }) => {
  const { t } = useTranslation();

  const statsData = [
    {
      key: 'total',
      label: t('total', 'Total'),
      value: stats.total,
      color: 'text-gray-900',
      icon: Hash,
      iconColor: 'text-gray-400'
    },
    {
      key: 'pending',
      label: t('pending', 'Pending'),
      value: stats.pending,
      color: 'text-yellow-600',
      icon: Clock,
      iconColor: 'text-yellow-400'
    },
    {
      key: 'ready',
      label: t('ready', 'Ready'),
      value: stats.ready,
      color: 'text-green-600',
      icon: Package,
      iconColor: 'text-green-400'
    },
    {
      key: 'inDelivery',
      label: t('inDelivery', 'In Delivery'),
      value: stats.inDelivery,
      color: 'text-purple-600',
      icon: Truck,
      iconColor: 'text-purple-400'
    },
    {
      key: 'delivered',
      label: t('delivered', 'Delivered'),
      value: stats.delivered,
      color: 'text-blue-600',
      icon: CheckCircle,
      iconColor: 'text-blue-400'
    }
  ];

  return (
    <div className="grid grid-cols-2 lg:grid-cols-5 gap-4">
      {statsData.map((stat) => {
        const IconComponent = stat.icon;
        return (
          <div key={stat.key} className="bg-white rounded-lg border border-gray-200 p-4">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-600">{stat.label}</p>
                <p className={`text-2xl font-bold ${stat.color}`}>{stat.value}</p>
              </div>
              <IconComponent className={`w-8 h-8 ${stat.iconColor}`} />
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default StatsCards;
